import { render, staticRenderFns } from "./MultiplePrintVarieties.vue?vue&type=template&id=5c18c4ba&scoped=true&"
import script from "./MultiplePrintVarieties.vue?vue&type=script&lang=js&"
export * from "./MultiplePrintVarieties.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePrintVarieties.vue?vue&type=style&index=0&id=5c18c4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18c4ba",
  null
  
)

export default component.exports